import { BaseQueryDTO } from './basequery-dto';

export class QueryPackageTemplatesForProposalDTO extends BaseQueryDTO
{
    IsSupplier: boolean;
    SupplierCode: string;
    PackageLevelTemplateIds: number[];
}

